import UploadFiles from '@stone/components/common/UploadFiles';
import { AccordionStepsActionTypes, AftercareActionTypes } from '@state/features/common.types';
import Button from '@stone/ui/button/Button';
// import analytics from '@utils/analytics';
import api from '@utils/api';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
const AftercareStep4 = (props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [formdef, setFormdef] = useState();
    const [errors, setErrors] = React.useState(false);
    useEffect(() => {
        let val = {};
        api.getForm('aftercare-files', val).then((data) => {
            setFormdef(data);
        });
    }, []);
    const onFileChange = () => {
        let val = {};
        api.getForm('aftercare-files', val).then((data) => {
            setFormdef(data);
        });
    };
    const navigate = () => {
        if (!formdef['file1'].htmlValue || !formdef['file2'].htmlValue || !formdef['file3'].htmlValue || !formdef['file4'].htmlValue || !formdef['file5'].htmlValue) {
            setErrors(true);
            return;
        }
        dispatch({
            type: AftercareActionTypes.FETCH_AFTERCARE,
        });
        dispatch({
            type: AccordionStepsActionTypes.NAVIGATE_STEP,
            payload: 'review',
        });
        // analytics.aftercareFour();
    };
    const handleGoBack = () => {
        dispatch({
            type: AccordionStepsActionTypes.NAVIGATE_STEP,
            payload: 'product',
        });
        // analytics.aftercareBackEdit('upload all required images', 'back');
    };
    if (!formdef) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("div", { className: "aftercare__form" },
        React.createElement("div", { className: "aftercare__form-images-upload" },
            React.createElement(UploadFiles, { formfield: "aftercare-files.file1", label: formdef['file1'].label, uploadedFile: formdef['file1'].htmlValue, filetype: "IMAGES", onFileChange: onFileChange, requiredError: errors && !formdef['file1'].htmlValue, tooltipText: t('aftercare.images.1.tooltip'), required: true }),
            React.createElement(UploadFiles, { formfield: "aftercare-files.file2", label: formdef['file2'].label, uploadedFile: formdef['file2'].htmlValue, filetype: "IMAGES", onFileChange: onFileChange, requiredError: errors && !formdef['file2'].htmlValue, tooltipText: t('aftercare.images.2.tooltip'), required: true }),
            React.createElement(UploadFiles, { formfield: "aftercare-files.file3", label: formdef['file3'].label, uploadedFile: formdef['file3'].htmlValue, filetype: "IMAGES", onFileChange: onFileChange, requiredError: errors && !formdef['file3'].htmlValue, tooltipText: t('aftercare.images.3.tooltip'), required: true }),
            React.createElement(UploadFiles, { formfield: "aftercare-files.file4", label: formdef['file4'].label, uploadedFile: formdef['file4'].htmlValue, filetype: "IMAGES", onFileChange: onFileChange, requiredError: errors && !formdef['file4'].htmlValue, tooltipText: t('aftercare.images.4.tooltip'), required: true }),
            React.createElement(UploadFiles, { formfield: "aftercare-files.file5", label: formdef['file5'].label, uploadedFile: formdef['file5'].htmlValue, filetype: "IMAGES", onFileChange: onFileChange, requiredError: errors && !formdef['file5'].htmlValue, tooltipText: t('aftercare.images.5.tooltip'), required: true }),
            React.createElement(UploadFiles, { formfield: "aftercare-files.file6", label: formdef['file6'].label, uploadedFile: formdef['file6'].htmlValue, filetype: "IMAGES", onFileChange: onFileChange })),
        React.createElement("div", { className: "row aftercare__form-btn-container" },
            React.createElement("div", { className: "col-lg-12 " },
                React.createElement(Button, { type: "button", cls: ['button--quaternary'], onClick: handleGoBack },
                    React.createElement(React.Fragment, null,
                        "< ",
                        t('button.back')))),
            React.createElement("div", { className: "col-lg-12" },
                React.createElement(Button, { type: "button", onClick: () => navigate(), cls: ['button--primary'], fullWidth: true }, t('aftercare.images.proceed'))))));
};
export default AftercareStep4;
